import { Box, styled } from "@mui/material"

export enum AsideSectionAreas {
  asideHeader = "asideHeader",
  contentHeader = "contentHeader",
  aside = "aside",
  content = "content",
}

export interface AsideSectionProps {
  hasHeader?: boolean
}

export const AsideSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasHeader",
})<AsideSectionProps>(({ theme, hasHeader = true }) => ({
  display: "grid",
  gridTemplateAreas: hasHeader
    ? ` "${AsideSectionAreas.asideHeader} ${AsideSectionAreas.contentHeader}"
        "${AsideSectionAreas.aside} ${AsideSectionAreas.content}"`
    : `"${AsideSectionAreas.aside} ${AsideSectionAreas.content}"`,
  gridTemplateColumns: "minmax(345px, 3fr) 7fr",
  rowGap: theme.spacing(3),
  columnGap: theme.spacing(6),
  alignItems: "flex-start",
}))
